export const PRICING_DATA = {
  pt: {
    numberOfAccounts: "Número de contas",
    extraAccount: "Conta extra",
    responsive: "Disponível em mobile",
    coverage: {
      name: "Cobertura",
      all: "Todas as regiões",
    },
    multiLang: "Plataforma multilíngue",
    avm: {
      name: "Modelo de Avaliação Automático",
      desc: "",
      basic: "Apartamentos e Moradias",
      pro: "Apartamentos e Moradias",
      proPlus:
        "Apartamentos, Moradias, Escritórios, Lojas, Terrenos, Quintas e Armazéns",
      ent: "Apartamentos, Moradias, Escritórios, Lojas, Terrenos, Quintas e Armazéns",
    },
    insights: {
      name: "Insights de mercado",
      desc: "O mercado em tempo real",
      basic: false,
      pro: false,
      proPlus: true,
      ent: true,
    },
    marketReports: {
      name: "Estudos de mercado",
      desc: "Ferramenta de criação de estudos de mercado",
      numberOfReport: {
        name: "Número de estudos de mercado",
        basic: "3",
        pro: "Ilimitado",
        proPlus: "Ilimitado",
        ent: "Ilimitado",
      },
      priceInterval: "Estimativas de intervalo de preço",
      rentYieldInterval: "Valores de Renda Mensal e Yield Anual",
      updateReport: "Opção de atualizar estudo de mercado",
      shareReport: "Partilha de estudos de mercado",
      printExport: "Imprimir e Exportar para PDF",
      comments: "Adicionar comentários",
      imageUpload: "Upload de imagens",
      similarProperties: "Análise de dados de imóveis semelhantes",
      editProperties: "Detalhes de imóvel editáveis",
      pointsOfInterest: "Pontos de interesse próximos",
      customExtraCharacteristics: "Características extra customizáveis",
      customStatus: {
        name: "Pipeline de estado do estudo de mercado",
        desc: "Perdido, ativo, angariado e vendido",
      },
      customReportPrice: "Preço do estudo de mercado customizável",
      priceIntervalConfidenceLevel: "Nível de confiança do intervalo de preços",
      transactionalData: {
        name: "Imóveis vendidos",
        desc: "Mediante acordo",
      },
      comparableProperties: {
        name: "Imóveis comparáveis",
        basic: "Automaticamente gerados",
        pro: "Automaticamente gerados e editáveis",
        proPlus: "Automaticamente gerados e editáveis",
        ent: "Automaticamente gerados e editáveis",
      },
      customInterval: "Intervalo de valores customizável",
      customReportLogo: "Logotipo do estudo de mercado customizável",
    },
    prospection: {
      name: "Prospeção de mercado",
      desc: "Ferramenta de prospeção de mercado",
      searchBy: {
        name: "Pesquisa por distrito, município, freguesia, zona ou vizinhança",
        desc: "Ferramenta de prospeção de mercado",
      },
      countryWide: {
        name: "Base de dados englobando todo o país atualizada diariamente, com entradas duplicadas filtradas",
        desc: "Mais de 300 mil imóveis únicos abrangendo cerca de 1 milhão de listados",
      },
      listed: "Ver onde os imóveis estão/estiveram listados",
      filterByDetails:
        "Filtrar por detalhes do imóvel, tempo no mercado, fonte, ID do imóvel",
      filterFSBO: "Filtrar por imóveis 'à venda pelo proprietário' (FSBO)",
      filterByExclusive: "Filtrar por imóveis 'à venda sem exclusividade'",
      mapSearch: "Prospeção com pesquisa por desenho de zona no mapa",
      liveListings: "Acesso a imóveis live e offline",
      alerts:
        "Opção de guardar pesquisa e receber alertas quando surgem novos resultados",
      collections: "Agrupar entradas em 'favoritos' ou em pastas",
    },
    marketInsights: {
      indicators: {
        name: "Estatísticas para a pesquisa e filtros selecionados",
        desc: "Preço, área & preço p/ metro quadrado médios, market cap, variação de preço, número de imóveis online (incluíndo oferta privada), e muitos mais!",
      },
      distributions: {
        name: "Veja como os dados de pesquisa estão distribuidos",
        desc: "Obtenha distribuições de: tipologia, tipo de promoção, exclusividade da oferta, preço, área, certificado energético, entre outros!",
      },
      timeSeries: {
        name: "Observe a sua pesquisa longo do tempo",
        desc: "Saiba como os preços p/ metro quadrado médios evoluiram ao longo do tempo, para vários tipos de imóveis!",
      },
      agencyMarketShare: {
        name: "Distribuição do mercado por agência",
        desc: "Número de imóveis por agência & correspondente quota de mercado",
      },
    },
    portfolio: {
      name: "Website pessoal",
      desc: "Versão base",
      pro: "Gratuito",
      proPlus: "Gratuito",
      ent: "Gratuito",
      customPortfolio: "Website pessoal customizável",
      transactionHistory: {
        name: "Histórico de imóveis vendidos",
        desc: "Opcional",
      },
      referredAssets: {
        name: "Imóveis angariados",
        desc: "Opcional",
      },
      testimonials: {
        name: "Testemunhos",
        desc: "Opcional",
      },
      blog: {
        name: "Blog",
        desc: "Optional",
      },
      contactForm: "Formulário de contacto",
      portfolioResponsive: "Disponível em mobile",
      portfolioMultiLang: "Multilíngue",
      freeSSL: "Certificado SSL gratuito",
      bandwidth: {
        name: "Tráfego",
        pro: "Ilimitado",
        proPlus: "Ilimitado",
        ent: "Ilimitado",
      },
      seoAnalytics: "SEO otimizado & Google Analytics",
    },
    admin: {
      name: "Painel de administrador",
      overview: {
        name: "Visualização do pipeline da equipa, agência e grupo",
        desc: "Ver estatísticas de imóveis ativos, angariados e vendidos com suporte de mapa",
      },
      userRanking: "Visualização de classificação dos utilizadores ",
      manageAccounts: {
        name: "Gerir contas de utilizadores",
        desc: "Criar, atualizar, suspender, apagar",
      },
      mandageCompanies: {
        name: "Gerir contas da agência",
        desc: "Para administradores de grupo",
      },
    },
    customBranding: {
      name: "Marca customizável",
      desc: "Logotipo da agência",
    },
  },
  en: {
    numberOfAccounts: "Number of accounts",
    extraAccount: "Extra account",
    responsive: "Mobile device friendly",
    coverage: {
      name: "Coverage",
      all: "All regions",
    },
    multiLang: "Multi language support",
    avm: {
      name: "Automated Valuation Model",
      desc: "",
      basic: "Houses and Apartments",
      pro: "Houses and Apartments",
      proPlus:
        "Houses, Apartments, Warehouses, Offices, Stores, Lands and Homesteads",
      ent: "Houses, Apartments, Warehouses, Offices, Stores, Lands and Homesteads",
    },
    insights: {
      name: "Market insights",
      desc: "Real time market monitoring",
      basic: false,
      pro: false,
      proPlus: true,
      ent: true,
    },
    marketReports: {
      name: "Market reports",
      desc: "Market report creation tool",
      numberOfReport: {
        name: "Number of market reports",
        basic: "3",
        pro: "Unlimited",
        proPlus: "Unlimited",
        ent: "Unlimited",
      },
      priceInterval: "Price interval estimates",
      rentYieldInterval: "Monthly Rent and Annual Yield Values",
      updateReport: "Updatable Report",
      shareReport: "Share Report",
      printExport: "Print & Export to PDF",
      comments: "Add comments",
      imageUpload: "Image upload",
      similarProperties: "Similar properties data analytics",
      editProperties: "Editable property details",
      pointsOfInterest: "Nearby points of interest",
      customExtraCharacteristics: "Custom extra characteristics",
      customStatus: {
        name: "Report status pipeline",
        desc: "Lost, active, referred & sold",
      },
      customReportPrice: "Custom report price",
      priceIntervalConfidenceLevel: "Price interval confidence level",
      transactionalData: {
        name: "Transactional data",
        desc: "Uppon accord",
      },
      comparableProperties: {
        name: "Comparable properties",
        basic: "Automaticaly generated",
        pro: "Automaticaly generated & editable",
        proPlus: "Automaticaly generated & editable",
        ent: "Automaticaly generated & editable",
      },
      customInterval: "Custom report price interval",
      customReportLogo: "Custom report logo",
    },
    prospection: {
      name: "Market prospection",
      desc: "Market prospection tool",
      searchBy: {
        name: "Search by district, county, parish, zone or neighbourhood",
        desc: "Market prospection tool",
      },
      countryWide: {
        name: "Country-wide dataset updated daily, with filtered duplicate entries",
        desc: "Over 300 thousand unique assets spanning 1 million listings",
      },
      listed: "See where assets are/were listed",
      filterByDetails:
        "Filter by property details, time on market, source, asset ID",
      filterFSBO: "Filter 'For Sale by Owner' (FSBO) assets",
      filterByExclusive: "Filter 'For Sale Wihout Exclusivity' assets",
      mapSearch: "Map based prospection w/ draw search",
      liveListings: "Access live & offline assets",
      alerts: "Save searches and receive alerts when new results appear",
      collections: "Group entries into favorites or named collections",
    },
    marketInsights: {
      indicators: {
        name: "Statistics for your selected search and filters",
        desc: "Avg. price, area & price per square meter, market cap, price variation, number of online properties (including private offer), and many more!",
      },
      distributions: {
        name: "Show how the search data is distributed",
        desc: "Get data distributions by: number of rooms, promotion type, offer exclusiveness, price, area, energy efficiency, among others!",
      },
      timeSeries: {
        name: "See the searched data across time",
        desc: "Know how selling prices per square meter evolved over time, across several asset types!",
      },
      agencyMarketShare: {
        name: "Agency Market Share",
        desc: "Number of properties per agency & corresponding market share",
      },
    },
    portfolio: {
      name: "Personal portfolio website",
      desc: "Basic version",
      pro: "Free",
      proPlus: "Free",
      ent: "Free",
      customPortfolio: "Customizable personal website",
      transactionHistory: {
        name: "Transactional history",
        desc: "Optional",
      },
      referredAssets: {
        name: "Referred assets",
        desc: "Optional",
      },
      testimonials: {
        name: "Testimonials",
        desc: "Optional",
      },
      blog: {
        name: "Blog",
        desc: "Optional",
      },
      contactForm: "Contact form",
      portfolioResponsive: "Mobile friendly",
      portfolioMultiLang: "Multi-language",
      freeSSL: "Free SSL certificate",
      bandwidth: {
        name: "Bandwidth",
        pro: "Unlimited",
        proPlus: "Unlimited",
        ent: "Unlimited",
      },
      seoAnalytics: "SEO optimized & Google Analytics",
    },
    admin: {
      name: "Admin dashboard",
      overview: {
        name: "Team, company and group pipeline overviews",
        desc: "See active, referred and sold properties statistics w/ map support",
      },
      userRanking: "User rankings overview ",
      manageAccounts: {
        name: "Manage user accounts",
        desc: "Create, update, suspend, delete",
      },
      mandageCompanies: {
        name: "Manage company accounts",
        desc: "For group admins",
      },
    },
    customBranding: {
      name: "Custom branding",
      desc: "Company logo",
    },
  },
  es: {
    numberOfAccounts: "Número de usuarios",
    extraAccount: "Cuenta extra",
    responsive: "Disponible en modo mobile",
    coverage: {
      name: "Cobertura",
      all: "Todas las provincias",
    },
    multiLang: "Plataforma multilingüe",
    avm: {
      name: "Modelo de Valoración Automático",
      desc: "",
      basic: "Pisos y Casas",
      pro: "Pisos y Casas",
      proPlus: "Pisos, Casas, Oficina, Local, Terrenos y Naves",
      ent: "Pisos, Casas, Oficina, Local, Terrenos y Naves",
    },
    insights: {
      name: "Estudios de mercado",
      desc: "El mercado en tiempo real",
      basic: false,
      pro: false,
      proPlus: true,
      ent: true,
    },
    marketReports: {
      name: "Valoraciones",
      desc: "Herramienta de valoraciones",
      numberOfReport: {
        name: "Número de valoraciones",
        basic: "3",
        pro: "ilimitado",
        proPlus: "ilimitado",
        ent: "ilimitado",
      },
      priceInterval: "Valoración con rango de precios",
      rentYieldInterval: "Valores de alquiler mensual y Yield Anual",
      updateReport: "Opción de actualizar las valoraciones",
      shareReport: "Compartir valoraciones",
      printExport: "Imprimir e Exportar para PDF",
      comments: "Incluir comentários",
      imageUpload: "Upload de imagenes",
      similarProperties: "Análisis de datos de inmuebles semejantes",
      editProperties: "Editar detalles del inmueble",
      pointsOfInterest: "Puntos de interes cercanos",
      customExtraCharacteristics: "Editar características extra",
      customStatus: {
        name: "Pipeline de status de la valoración",
        desc: "Perdido, activo, captado y vendido",
      },
      customReportPrice: "Editar precio de la valoración",
      priceIntervalConfidenceLevel:
        "Nivel de confianza del rango de precios de la valoración",
      transactionalData: {
        name: "Inmuebles vendidos",
        desc: "Mediante acuerdo",
      },
      comparableProperties: {
        name: "Inmuebles comparables",
        basic: "Automaticamente generados",
        pro: "Automaticamente generados y editable",
        proPlus: "Automaticamente generados y editable",
        ent: "Automaticamente generados y editable",
      },
      customInterval: "Intervalo de precio de informe personalizado",
      customReportLogo: "Editar logotipo de la valoración",
    },
    prospection: {
      name: "Captación Leads",
      desc: "Herramienta de captación de leads",
      searchBy: {
        name: "Búsqueda por provincia, município, distrito, y barrio",
        desc: "Herramienta de captación de leads",
      },
      countryWide: {
        name: "Base de datos actualizada diariamente, con duplicadas filtradas",
        desc: "Miles de inmuebles únicos",
      },
      listed: "Ver donde los inmuebles están/estuvieron listados",
      filterByDetails:
        "Filtrar por detalles del inmueble, tiempo en el mercado, fuente, ID del inmueble",
      filterFSBO:
        "Filtrar por inmuebles 'a la venta por el propietário' (FSBO)",
      filterByExclusive:
        "Filtrar por inmuebles 'a la venta sin acuerdo de exclusividad",
      mapSearch: "Captación y búsqueda por diseño en el mapa",
      liveListings: "Acceso a inmuebles live y offline",
      alerts:
        "Opción de guardar busquedas y recibir alertas cuando surjan nuevos resultados",
      collections: "Agrupar anúncios en 'favoritos' o en colecciones",
    },
    marketInsights: {
      indicators: {
        name: "Estadísticas para la búsqueda y filtros seleccionados",
        desc: "Precio, área & precio por metro cuadrado promedio, market cap, variación de precio, numero de inmuebles online (incluyendo oferta privada), y mucho más!",
      },
      distributions: {
        name: "Vea como los datos de búsqueda están distribuidos",
        desc: "Obtenga distribuciones de: nro de cuartos, tipo de anuncio, exclusividad de oferta, precio, área, certificado energético, entre otros!",
      },
      timeSeries: {
        name: "Observe su búsqueda a lo largo del tiempo",
        desc: "Sepa como los precios promedio por metro cuadrado se desarrollaron a lo largo del tiempo, para varios tipos de inmuebles!",
      },
      agencyMarketShare: {
        name: "Distribución de mercado por agencia",
        desc: "Número de inmuebles por agencia y correspondiente cuota de mercado",
      },
    },
    portfolio: {
      name: "Website personal",
      desc: "Versión base",
      pro: "Gratuito",
      proPlus: "Gratuito",
      ent: "Gratuito",
      customPortfolio: "Editar Website personal",
      transactionHistory: {
        name: "Histórico de inmuebles vendidos",
        desc: "Opcional",
      },
      referredAssets: {
        name: "Inmuebles captados",
        desc: "Opcional",
      },
      testimonials: {
        name: "Testimonios",
        desc: "Opcional",
      },
      blog: {
        name: "Blog",
        desc: "Optional",
      },
      contactForm: "Formulário de contacto",
      portfolioResponsive: "Disponible para el móvil",
      portfolioMultiLang: "Multilingüe",
      freeSSL: "Certificado SSL gratis",
      bandwidth: {
        name: "Capacidad",
        pro: "Ilimitada",
        proPlus: "Ilimitada",
        ent: "Ilimitada",
      },
      seoAnalytics: "SEO optimizado & Google Analytics",
    },
    admin: {
      name: "Panel de administrador",
      overview: {
        name: "Visualización del pipeline del equipo, agencia y grupo",
        desc: "Ver estadísticas de inmuebles activos, captados y vendidos con el soporte del mapa",
      },
      userRanking: "Visualización de clasificación de los usuários",
      manageAccounts: {
        name: "Gerenciar cuentas de los usuários",
        desc: "Crear, actualizar, suspender, eliminar",
      },
      mandageCompanies: {
        name: "Gerenciar cuentas de la agencia",
        desc: "Para administradores del grupo",
      },
    },
    customBranding: {
      name: "Editar marca",
      desc: "Logotipo de la agencia",
    },
  },
};

export const PRICING_DATA_LEADS = {
  pt: {
    landingPage: {
      name: "Landing page empresarial",
      desc: "Para grupos, agências e consultores",
      leadsOverview: {
        name: "Painel de visualização das leads",
        desc: "Ver estatísticas de grupo, agências, equipas e agentes",
      },
      userLandingPage: "Landing page do utilizador",
      companyLandingPage: "Landing page da agência",
      distributeLeads:
        "Distribuição de leads por localização do utilizador, localização da agência ou aleatoriamente",
    },
    site: {
      name: "Website pessoal",
      desc: "Versão Pro por pessoa por ano",
      basicFeatures: "Todas as funcionalidades da versão básica do website",
      logo: "Logo customizável",
      domain: "Domínio (link) customizável",
      leads: "Geração de leads com validação por SMS",
    },
  },
  en: {
    landingPage: {
      name: "Enterprise landing page",
      desc: "For groups, companies and agents",
      leadsOverview: {
        name: "Leads overview dashboard",
        desc: "View group, companies, teams and agent's statistics",
      },
      userLandingPage: "User landing page",
      companyLandingPage: "Company landing page",
      distributeLeads:
        "Distribute leads by user location, agency location or randomly",
    },
    site: {
      name: "Personal portfolio website",
      desc: "Pro version per person per year",
      basicFeatures: "All Basic personal portfolio website features",
      logo: "Custom logo",
      domain: "Custom domain",
      leads: "Leads generation w/ SMS validation",
    },
  },
  es: {
    landingPage: {
      name: "Landing page empresarial",
      desc: "Para grupos, agencias y agentes",
      leadsOverview: {
        name: "Pánel de visualización de los contactos de captación",
        desc: "Ver estadísticas de grupo, agencias, equipos y agentes",
      },
      userLandingPage: "Landing page del usuário",
      companyLandingPage: "Landing page de la agencia",
      distributeLeads:
        "Distribución de contactos de captación por localización del usuário, localización de la agencia o aleatóriamente",
    },
    site: {
      name: "Website personal",
      desc: "Versión pro por persona por año",
      basicFeatures: "Todas las funciones de la versión básica del website",
      logo: "Editar logo",
      domain: "Editar el la dirección web (link)",
      leads: "Generar contactos de captación validados por SMS",
    },
  },
};

export const PRICING = {
  pt: {
    title: "Preçário",
    subTitle: "Evolua de acordo com as suas necessidades",
    t2: "A nossa plataforma",
    features: "Benefícios",
    month: "month",
    semester: "semestre",
    year: "ano",
    vat: "valores não incluem IVA",
    extra: "*opcional - não incluído **opcional - protocolo necessário",
    basic: {
      label: "Básica",
      buttonLabel: "Registar",
      url: `register`,
    },
    professional: {
      label: "Profissional",
      labelShort: "Pro",
      buttonLabel: "Subscrever",
    },
    professionalPlus: {
      label: "Profissional Plus",
      labelShort: "Pro+",
      buttonLabel: "Subscrever",
    },
    enterprise: {
      label: "Enterprise",
      buttonLabel: "Subscrever",
    },
    ...PRICING_DATA.pt,
    ...PRICING_DATA_LEADS.pt,
  },
  en: {
    title: "Pricing Plans",
    subTitle: "A solution for your every day needs",
    t2: "Our Platform",
    features: "Features",
    month: "mês",
    semester: "semester",
    year: "year",
    vat: "values do not include VAT",
    extra: "*optional - not included **collaboration protocol needed",
    basic: {
      label: "Basic",
      buttonLabel: "Start",
    },
    professional: {
      label: "Professional",
      labelShort: "Pro",
      buttonLabel: "Subscribe",
    },
    professionalPlus: {
      label: "Professional Plus",
      labelShort: "Pro+",
      buttonLabel: "Subscribe",
    },
    enterprise: {
      label: "Enterprise",
      buttonLabel: "Subscribe",
    },
    ...PRICING_DATA.en,
    ...PRICING_DATA_LEADS.en,
  },
  es: {
    title: "Precios",
    subTitle: "Progrese de acuerdo a sus necesidades",
    t2: "Nuestra Plataforma",
    features: "Beneficios",
    month: "mes",
    semester: "semestre",
    year: "año",
    vat: "valores sin IVA",
    extra: "*opcional - no incluido **opcional - protocolo necessário",
    basic: {
      label: "Básica",
      buttonLabel: "Registar",
    },
    professional: {
      label: "Profesional",
      labelShort: "Pro",
      buttonLabel: "Inscribir",
    },
    professionalPlus: {
      label: "Profesional Plus",
      labelShort: "Pro+",
      buttonLabel: "Inscribir",
    },
    enterprise: {
      label: "Enterprise",
      buttonLabel: "Inscribir",
    },
    ...PRICING_DATA.es,
    ...PRICING_DATA_LEADS.es,
  },
};

export const PLAN_CARDS = {
  pt: {
    month: "mês",
    try: "Experimentar",
    basic: {
      title: "Standard",
      price: "Grátis",
      description:
        "Este plano dá-lhe a oportunidade de testar a nossa plataforma e perceber que benefícios lhe poderá trazer. Tem acesso a 3 estudos de mercado gratuitos e pode criar o seu website, ajudando-lhe a estabelecer uma presença online e alcançar novos clientes.",
      cta: "Registar",
    },
    professional: {
      title: "Pro",
      description:
        "A nossa plataforma simplifica o processo de atendimento e de prospecção de novos clientes, dando-lhe estudos de mercado ilimitados para apartamentos e moradias, bem como e todas as informações de mercado que precisa, tudo num único lugar.",
      cta: "Subscrever",
    },
    professionalPlus: {
      title: "Pro+",
      description:
        "Dê resposta a qualquer solicitação dos seus clientes através de estudos de mercado para qualquer tipo de imóvel, incluindo terrenos e lojas. Com a nossa ferramenta de estatísticas de mercado, apresente ao seu cliente indicadores únicos.",
      cta: "Subscrever",
    },
    enterprise: {
      title: "Enterprise",
      description:
        "Para brokers que desejam fornecer à sua equipa as melhores ferramentas disponíveis, com acesso ao módulo de gestão de utilizadores, personalização de todos os estudos de mercado com o logotipo da sua agência e medição de desempenho.",
      cta: "Subscrever",
    },
  },
  en: {
    month: "month",
    try: "Try it",
    basic: {
      title: "Standard",
      price: "Free",
      description: `
        This plan gives you the opportunity to test our platform and see the benefits
        for yourself. You'll receive 3 free market reports and your own custom-branded
        website, helping you establish an online presence and reach new customers.
      `,
      cta: "Sign Up",
    },
    professional: {
      title: "Pro",
      description: `
        Our platform simplifies the process of assisting and connecting with clients,
        providing you with access to unlimited property valuation reports for houses
        and apartments, and all the market information you need, all in one convenient
        location.
      `,
      cta: "Subscribe",
    },
    professionalPlus: {
      title: "Pro+",
      description: `
        Maximize your business performance by creating market reports for all asset types,
        including lands and stores. Enhance your customer service and market expertise
        with our market insights tool, featuring unique statistics and trend analysis.
      `,
      cta: "Subscribe",
    },
    enterprise: {
      title: "Enterprise",
      description: `
        For business owners looking to provide their team with the best tools available,
        our platform offers management of multiple accounts, customization of all market
        reports with your agency logo and real-time performance tracking.
      `,
      cta: "Subscribe",
    },
  },
  es: {
    month: "mes",
    try: "Experimentar",
    basic: {
      title: "Standard",
      price: "Gratis",
      description:
        "Si desea la oportunidad de probarlo, este plan ofrece 3 estudios de mercado y su propio sitio web personal para tener una presencia online, logrando así, más clientes.",
      cta: "Regístrese",
    },
    professional: {
      title: "Pro",
      description:
        "Una herramienta diaria que le permite ayudar y llegar a sus clientes de una forma más fácil y efectiva, con valoraciones ilimitadas para casas, apartamentos y todo el mercado inmobiliario, accesible desde un solo lugar.",
      cta: "Suscribirse",
    },
    professionalPlus: {
      title: "Pro+",
      description:
        "Lleve su desempeño más allá, refuerce la conexión con todo tipo de clientes a través de valoraciones para cualquier categoría de propiedad, incluyendo terrenos. Divulgue su marca personalizando el logotipo y el dominio de su web.",
      cta: "Suscribirse",
    },
    enterprise: {
      title: "Enterprise",
      description:
        "Para los empresarios que deseen obtener las mejores herramientas para sus agentes, administrar múltiples cuentas, personalizar todas las valoraciones con su logotipo y obtener una visión general del rendimiento de su agencia.",
      cta: "Suscribirse",
    },
  },
};
